import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContentPage } from 'src/app/enums/content-page.enum';
import { IProductsRecipe } from 'src/app/interfaces/product-recipe.interface';

@Component({
  selector: 'app-recipe-detail',
  templateUrl: './recipe-detail.component.html',
  styleUrls: ['./recipe-detail.component.scss']
})
export class RecipeDetailComponent implements OnInit {
  crumbs: any[]=[];
  general = ContentPage.esES.recipes;
  productRecipe: IProductsRecipe;
  recommendedRecipes: IProductsRecipe[] = [];
  recipeId: number = 0;
  language: string;

  constructor(
    private activeroute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.language = localStorage.getItem('language');
    if (this.language == 'esEN') {
      this.general = this.language == 'esEN' ? ContentPage.esEN.recipes : ContentPage.esES.recipes;
    }
    this.getRecipe(null);
    this.setCrumbs();
  }

  getRecipe(id:number){
    this.recipeId = !id ? +this.activeroute.snapshot.paramMap.get('id') : id;
    this.productRecipe = this.language == 'esEN' ? ContentPage.esEN.recipes.products.find((element)=> element.id == this.recipeId) :
    ContentPage.esES.recipes.products.find((element)=> element.id == this.recipeId);
    let productsTemp = this.language == 'esEN' ? ContentPage.esEN.recipes.products : ContentPage.esES.recipes.products;
    this.recommendedRecipes = productsTemp.filter((element)=> element.id != this.recipeId && element.type == this.productRecipe.type);
  }

  setCrumbs(){
    //console.log(this.productRecipe)
    this.crumbs = this.general.crumbs.slice(0,2);
    let findCategorie = this.general.types.find((element)=> element.type == this.productRecipe.type);
    this.crumbs.push({
      label: findCategorie.name,
      url: '/recetas'
    })
    let findProduct = this.general.products.find((element)=> element.id == this.productRecipe.id);
    this.crumbs.push({
      label: findProduct.title,
      url: ''
    })
  }
  
}
